import React, { useState, useEffect } from 'react';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import classNames from 'classnames';
import EditableSection from 'components/v2/EditableSection';
import Select from 'components/v2/select';
import { Translation, useTranslation } from 'react-i18next';
import { checkPermissonForEditShipperBillingModule, payloadMappingOnlyForChanges, } from '../utils';
const scheduleOptions = [
    { slug: 'individual', localizationSlug: 'INDIVIDUAL' },
    { slug: 'daily', localizationSlug: 'DAILY' },
    { slug: 'weekly', localizationSlug: 'WEEKLY' },
];
const scheduleInfo = (React.createElement(Translation, null, (t) => (React.createElement("div", null,
    React.createElement("div", null,
        " ",
        t('INVOICE_SCHEDULE_TOOLTIP_INDIVIDUAL'),
        " "),
    React.createElement("div", null,
        " ",
        t('INVOICE_SCHEDULE_TOOLTIP_DAILY'),
        " "),
    React.createElement("div", null,
        " ",
        t('INVOICE_SCHEDULE_TOOLTIP_WEEKLY'),
        " ")))));
const ShorthaulInvoiceSettingsSummary = ({ fields = {} }) => {
    var _a;
    const { t } = useTranslation();
    return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
        React.createElement(DescriptionListItem, { label: t('INVOICE_SCHEDULE'), className: "", info: scheduleInfo }, t(((_a = scheduleOptions.find((o) => o.slug === (fields === null || fields === void 0 ? void 0 : fields.invoice_schedule))) === null || _a === void 0 ? void 0 : _a.localizationSlug) || ''))));
};
const ShorthaulInvoiceSettingsForm = ({ fields, onChange, saving, onSaveShipper, onSaveSuccess, onSaveFail, }) => {
    const { t } = useTranslation();
    const saveForm = async () => {
        try {
            await onSaveShipper();
            onSaveSuccess(fields);
        }
        catch (e) {
            onSaveFail();
        }
    };
    useEffect(() => {
        if (saving) {
            saveForm();
        }
    }, [saving]);
    return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
        React.createElement("div", null,
            React.createElement(Select, { label: t('INVOICE_SCHEDULE'), items: scheduleOptions, info: scheduleInfo, valueKey: "slug", textKey: "localizationSlug", selected: fields.invoice_schedule, onSelect: ({ slug }) => onChange('invoice_schedule', slug) }))));
};
const ShorthaulInvoiceSettings = ({ data, className, onUpdateShipper }) => {
    const [initialData, setInitialData] = useState(data);
    const [shorthaulInvoiceSettingsData, setShorthaulInvoiceSettingsData] = useState(data);
    const { t } = useTranslation();
    const onChange = (field, value) => {
        setShorthaulInvoiceSettingsData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    const handleSave = async () => {
        const payload = payloadMappingOnlyForChanges(initialData, shorthaulInvoiceSettingsData);
        if (Object.keys(payload).length) {
            await onUpdateShipper(payload);
        }
    };
    const handleAfterSave = (onSaveSuccess) => {
        return (updatedData = {}) => {
            setInitialData((prev) => (Object.assign(Object.assign({}, prev), updatedData)));
            onSaveSuccess();
        };
    };
    return (React.createElement(EditableSection, { title: t('INVOICE'), className: classNames(className), canEdit: checkPermissonForEditShipperBillingModule() }, (editing, saving, onSaveSuccess, onSaveFail) => (React.createElement(React.Fragment, null,
        !editing && React.createElement(ShorthaulInvoiceSettingsSummary, { fields: initialData }),
        editing && (React.createElement(ShorthaulInvoiceSettingsForm, { fields: shorthaulInvoiceSettingsData, onChange: onChange, onSaveShipper: () => handleSave(), saving: saving, onSaveSuccess: handleAfterSave(onSaveSuccess), onSaveFail: onSaveFail }))))));
};
export default ShorthaulInvoiceSettings;
